<template>
  <div class="m-container">
    <m_header></m_header>
    <m_menu></m_menu>
    <div class="m-body">
      <el-container class="m-title-box">
        <div class="m-title">
          <div class="m-title-t">学习目标管理</div>
          <span class="m-title-s">对用户学习目标进行新增、编辑等操作</span>
        </div>
        <div class="m-tips">
          <i class="el-icon-warning"></i>使用提示
        </div>
      </el-container>
      <div class="m-table">
        <el-container class="m-table-head">
          <div class="m-table-title">
            <i class="el-icon-s-opportunity"></i>学习目标列表
          </div>
          <div class="m-table-btn">
            <el-button @click="openPopup" type="primary" size="">新增学习目标</el-button>
          </div>
        </el-container>
        <el-table :data="list" v-loading="isLoading" style="width: 100%;margin-bottom: 20px;" border>
          <el-table-column prop="name" label="目标名称" width="220"></el-table-column>
          <el-table-column prop="value" label="目标编号" width="130" align="center"></el-table-column>
          <el-table-column prop="sort" label="排序" width="110" align="center"></el-table-column>
          <el-table-column prop="remarks" label="备注"></el-table-column>
          <el-table-column label="操作" width="160" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="openForm(scope.row.id)" plain>编辑</el-button>
              <el-button type="danger" size="mini" @click="thisDel(scope.row.id, scope.row.name)" plain>删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog :title="openText" :visible.sync="openState" @close='closeDialog' width="600px" center :close-on-click-modal="false">
      <div class="m-open-container">
        <div class="zs-open-body-ov">
          <el-form :model="form" :rules="rules" ref="form" label-width="125px">
            <el-form-item label="ID" prop="id" hidden>
              <el-input v-model="form.id" type="hidden"></el-input>
            </el-form-item>
            <el-form-item label="目标名称: " prop="name">
              <el-input v-model="form.name" placeholder="输入目标名称"></el-input>
            </el-form-item>
            <el-form-item label="目标编号: " prop="value">
              <el-input v-model="form.value" placeholder="输入目标编号"></el-input>
            </el-form-item>
            <el-form-item label="排序: " prop="sort">
              <el-input v-model="form.sort" placeholder="输入排序"></el-input>
            </el-form-item>
            <el-form-item label="备注说明: " prop="remarks">
              <el-input v-model="form.remarks" type="textarea" :rows="2" placeholder="输入备注说明"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-foote" style="text-align: center;" v-loading="formLoading">
          <el-button @click="closeDialog">取 消</el-button>
          <el-button type="primary" @click="submit()">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Manager',
  data () {
    return {
      openText: '新增',
      openState: false,
      formLoading: false,
      isLoading: true,
      list: [],
      roleList: [],
      form: {
        id: '',
        name: '',
        value: '',
        sort: '',
        remarks: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入目标名称', trigger: 'blur' }
        ],
        value: [
          { required: true, message: '请输入目标编号', trigger: 'blur' }
        ],
        sort: [
          { required: true, message: '请输入排序', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    closeDialog: function () {
      this.form = {
        id: '',
        name: '',
        value: '',
        sort: '',
        remarks: ''
      }
      this.openText = '新增'
      this.openState = false
      this.formLoading = false
    },
    openPopup () {
      this.openState = true
    },
    submit () {
      let _this = this
      this.$refs['form'].validate((valid) => {
        if (valid) {
          _this.formLoading = true
          let url = _this.form.id === '' ? '/admin/targetAdd' : '/admin/targetEdit'
          this.$axios.post(url, _this.form)
            .then((res) => {
              if (res.code === 200) {
                _this.$message({
                  message: res.msg,
                  type: 'success',
                  center: true,
                  onClose: function () {
                    _this.listData()
                    _this.openState = false
                    _this.formLoading = false
                  }
                })
              } else {
                _this.$message({
                  message: res.msg,
                  type: 'error',
                  center: true,
                  onClose: function () {
                    _this.formLoading = false
                  }
                })
              }
            })
        } else {
          return false
        }
      })
    },
    thisDel (id, title) {
      let _this = this
      this.$messageBox.confirm('此操作将永久删除[' + title + '], 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        this.$axios.post('/admin/targetDel', {id: id})
          .then((res) => {
            if (res.code === 200) {
              _this.$message({
                type: 'success',
                duration: '800',
                message: res.msg,
                onClose: function () {
                  _this.listData()
                }
              })
            } else {
              _this.$message({
                type: 'error',
                duration: '800',
                message: res.msg
              })
            }
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    openForm (id) {
      let _this = this
      this.openText = '编辑'
      _this.formLoading = true
      this.$axios.post('/admin/targetForm', {id: id})
        .then((res) => {
          if (res.code === 200) {
            _this.form = res.data
            _this.isLoading = false
            _this.openState = true
            _this.formLoading = false
          } else {
            _this.$message({
              type: 'error',
              duration: '800',
              message: res.msg
            })
          }
        })
    },
    // 管理员列表
    listData () {
      let _this = this
      this.isLoading = true
      _this.list = []
      this.$axios.post('/admin/targetList')
        .then((res) => {
          _this.list = res.data
          _this.isLoading = false
        })
    }
  },
  mounted () {
    this.listData()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/TargetManage.vue